(() => {
  const MOTION_SELECTOR = '[data-ntp-motion="quiet"], [data-ntp-motion="editorial"], [data-ntp-motion="image"]';
  const GROUP_SELECTOR = '[data-ntp-motion-group]';
  const STAGGER_STEP_MS = 80;
  const MAX_STAGGER_STEPS = 5;
  const durations = {
    quiet: 520,
    editorial: 680,
    image: 820,
  };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  const isDesignMode = () => Boolean(window.Shopify?.designMode || document.documentElement.classList.contains('shopify-design-mode'));

  const motionElementsWithin = (root) => {
    const elements = [];

    if (root instanceof Element && root.matches(MOTION_SELECTOR)) {
      elements.push(root);
    }

    if ('querySelectorAll' in root) {
      elements.push(...root.querySelectorAll(MOTION_SELECTOR));
    }

    return elements;
  };

  const complete = (element) => {
    element.removeAttribute('data-ntp-motion-state');
    element.style.removeProperty('--ntp-motion-delay');
    element.dataset.ntpMotionComplete = 'true';
  };

  const reveal = (element, immediately = false) => {
    observer?.unobserve(element);

    if (immediately) {
      complete(element);
      return;
    }

    element.dataset.ntpMotionState = 'visible';

    const delay = Number.parseInt(element.style.getPropertyValue('--ntp-motion-delay'), 10) || 0;
    const duration = durations[element.dataset.ntpMotion] || durations.editorial;
    window.setTimeout(() => complete(element), delay + duration + 100);
  };

  const makeStatic = (root) => {
    motionElementsWithin(root).forEach((element) => reveal(element, true));
  };

  const isAlreadyVisible = (element) => {
    const bounds = element.getBoundingClientRect();
    return bounds.bottom > 0 && bounds.top < window.innerHeight * 0.92;
  };

  const initialize = (root = document) => {
    if (!observer || reduceMotion.matches || isDesignMode()) {
      makeStatic(root);
      return;
    }

    const groupIndexes = new Map();

    motionElementsWithin(root).forEach((element) => {
      if (element.dataset.ntpMotionComplete === 'true' || element.dataset.ntpMotionState) return;

      if (isAlreadyVisible(element)) {
        complete(element);
        return;
      }

      const group = element.closest(GROUP_SELECTOR);
      const groupIndex = group ? groupIndexes.get(group) || 0 : 0;
      const staggerStep = Math.min(groupIndex, MAX_STAGGER_STEPS);

      if (group) groupIndexes.set(group, groupIndex + 1);

      element.style.setProperty('--ntp-motion-delay', `${staggerStep * STAGGER_STEP_MS}ms`);

      try {
        observer.observe(element);
        element.dataset.ntpMotionState = 'pending';
      } catch (error) {
        reveal(element, true);
      }
    });
  };

  if (!reduceMotion.matches && !isDesignMode() && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting || entry.intersectionRatio > 0) reveal(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      }
    );
  }

  initialize();

  reduceMotion.addEventListener('change', (event) => {
    if (event.matches) makeStatic(document);
  });

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    motionElementsWithin(event.target).forEach((element) => observer?.unobserve(element));
  });
})();
